import { Dispatch, SetStateAction } from "react"

export const copyText = async (
  text: string,
  setIsCopied: Dispatch<SetStateAction<boolean>>
) => {
  await navigator.clipboard.writeText(text)
  setIsCopied(true)
  setTimeout(() => {
    setIsCopied(false)
  }, 1500)
}
